var simpleRoutes = angular.module('simpleRoutes', []);

simpleRoutes.config(function($routeProvider, $locationProvider) {
	$locationProvider.html5Mode(true);
	
	$routeProvider
		.when("/", {
	        templateUrl: function(params) {
	        	if(params.s){
	        		return WPAPI.template_url+"/views/search.html";
	        	}else{
	        		return WPAPI.template_url+"/views/front-page.html";
	        	}	
	        },
	        controller: 'homeCtrl'
		})
		.when( "/artikler/", {
	        templateUrl: WPAPI.template_url+"/views/archive-post.html",
	        controller: 'postCtrl',
	    })
	    .when( "/artikler/:post", {
	        templateUrl: WPAPI.template_url+"/views/single-post.html",
	        controller: 'singlePostCtrl',
	    })
	    .when( "/filmer/", {
	        templateUrl: WPAPI.template_url+"/views/archive-filmer.html",
	        controller: 'filmerCtrl',
	    })
	    .when( "/filmer/:post", {
	        templateUrl: WPAPI.template_url+"/views/single-filmer.html",
	        controller: 'singleFilmCtrl',
	    })
	    .when( "/oppskrifter/", {
	        templateUrl: WPAPI.template_url+"/views/archive-oppskrifter.html",
	        controller: 'oppskrifterCtrl',
	    })
	    .when( "/oppskrifter/:oppskrift", {
	        templateUrl: WPAPI.template_url+"/views/single-oppskrifter.html",
	        controller: 'singleOppskriftCtrl',
	    })
	    .when('/category/:category', {
			templateUrl: WPAPI.template_url +'/views/category.html',
			controller: 'categoryCtrl'
		})
		.when('/category/:parentcategory/:category', {
			templateUrl: WPAPI.template_url +'/views/category.html',
			controller: 'categoryCtrl'
		})
	   	.when( "/:page", {
	        templateUrl: WPAPI.template_url+"/views/page.html",
	        controller: 'pageCtrl',
	    })
		.when('/404/', {
		    templateUrl: WPAPI.template_url+"/views/404.html",
		});
});